import { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import HomePage from "./HomePage";
import VeterinaryConditions from "./VeterinaryConditions";
import HandOutDetails from "./HandOutDetails";
import SearchTopics from "./SearchTopics";
import TopicDetail from "./TopicDetail";
import SpecialityTopics from "./SpecialityTopics";
import PageNotFound from "./PageNotFound";
import Footer from "../components/Footer";
import "../styles/styles.css";
import Subscriptionpage from "../components/subscription/SubscriptionPage";
import LoginSignupComponent from "../components/loginSignupComponent/loginSignupComponent";
import LoginModalScreen from "../components/LoginModalScreen/LoginModalScreen";
import { connect } from "react-redux";
import { ToastProvider } from "react-toast-notifications";
import { genusAction } from "../redux/actions/genusAction";
import config from "../config/config";
import { loadScript } from "../utils/loadScript";

class App extends Component {
  componentDidMount = () => {
    this.props.checkLoginSession();
    this.props.getGenus();
    loadScript(config.ADOBE_ANALYTICS_SCRIPT_URL, { id: "adobe-launch" }).catch(() => {});
  };

  componentDidUpdate = () => {
    this.props.checkLoginSession();
  };

  render() {
    return (
      <ToastProvider placement="top-center">
        <div
          className={
            this.props.loginModalOpen ? "app-wrapper-scroll-stop" : null
          }
        >
          {this.props.loginModalOpen ? <LoginModalScreen /> : null}
          <Switch>
            <Route exact path="/" component={VeterinaryConditions} />
            <Route
              exact
              path="/non-free-topic"
              component={LoginSignupComponent}
            />
            <Route path="/vetconsult" component={HomePage} />
            <Route path="/handout-details" component={HandOutDetails} />
            <Route
              path="/topic-search/:searchkey/:searchgenus"
              component={SearchTopics}
            />
            <Route path="/topic/:specialty/:id" component={TopicDetail} />
            <Route path="/specialty/:id" component={SpecialityTopics} />
            <Route path="/subscription" component={Subscriptionpage} />
            <Route component={PageNotFound} />
          </Switch>
          {this.props.location.pathname === "/non-free-topic" ? null : (
            <Footer />
          )}
        </div>
      </ToastProvider>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  checkLoginSession: () => dispatch({ type: "LOGIN_SESSION_CHECK" }),
  getGenus: () => dispatch(genusAction()),
});

const mapStateToProps = (state) => ({
  loginModalOpen: state.loginReducer.loginModalOpen,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));